import './index.scss';

import {inject, observer} from 'mobx-react';
import {hotelTabs} from '../../tools';
import SightHotelItem from '../SightHotelItem';

@inject(({store}) => {
    return {
        hotelTab: store.hotelTab,
        showHotelList: store.showHotelList,
        changeTab: store.changeTab
    };
})
@observer
class Hotels extends React.Component {
    state = {
        activeIndex: 0,
        isMore: true
    }

    setActiveIndex(index, id) {
        let {activeIndex} = this.state;
        if (activeIndex === index) {
            return;
        } else {
            this.setState({activeIndex: index});
        }
        this.props.changeTab(id, 'hotel');
    }

    changeMore() {
        this.setState({isMore: !this.state.isMore});
    }

    render() {
        const {hotelTab, showHotelList} = this.props;
        const {activeIndex} = this.state;
        if (!showHotelList.length) {
            return null;
        }
        return (
            <div className="hotels">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/title3.jpg"/>
                <div className="hotel">
                    <div className="hotel-tab">
                        {
                            hotelTab.map((item, index) => {
                                return (
                                    <div
                                        className={`hotel-tab-item ${index === activeIndex ? 'active' : ''}`}
                                        key={item.id}
                                        data-sk-eid={hotelTabs[index]}
                                        onClick={() => this.setActiveIndex(index, item.id)}
                                    >
                                        {item.title}
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="hotel-list">
                        {
                            showHotelList.map((hotel, index) => {
                                if (index >= 4 && isMore) return null;
                                return <SightHotelItem data={hotel} eIndex={(activeIndex * 4 + index + 1) > 9 ? (activeIndex * 4 + index + 1) : '0' + (activeIndex * 4 + index + 1)}/>;
                            })
                        }
                    </div>
                    {
                        showHotelList.length > 4 ? <div className="more" onClick={() => this.changeMore()}>{isMore ? '查看更多' : '收起'}</div> : null
                    }
                </div>
            </div>
        );
    }
}

export default Hotels;